import React, { useState, useEffect } from "react";
import * as Icons from "heroicons-react";
import { Textarea } from "react-daisyui";
import SelectPriceGrn from "../Common/CustomSelect/ScelectPriceGrn";
import SelectTpDamage from "../Common/CustomSelect/SelectTpDamage";

const DamageProducts = ({
  damageProducts,
  i,
  //   removeQuantities,
  handleCustomQty,
  //   addQuantities,
  removeFromCart,
  handleCustomReason,
  handleOnChangePrice,
}) => {
  const [tempQty, setTempQty] = useState([]);

  useEffect(() => {
    let cartTempQty = [];

    damageProducts?.map((item) => {
      cartTempQty = [...cartTempQty, { id: item.article_code, qty: item.qty }];
    });
    setTempQty(cartTempQty);
  }, [damageProducts]);
  // console.log(damageProducts);

  return (
    <>
      {damageProducts?.length > 0 ? (
        damageProducts
          ?.slice()
          ?.sort((a, b) => a.order - b.order)
          // sorting a problem hosse // pleas check
          ?.map((item) => (
            <tr key={item?.order}>
              <th>{i++}</th>
              {/* <td>{item?.ean}</td> */}
              <td>{item?.article_code}</td>
              <td>{item?.name}</td>
              {/* <td>{item?.qty}</td> */}
              <td className="col-md-2">
                <div className="input-group ">
                  {/* quantity */}
                  <input
                    type="text"
                    className="form-control quantity"
                    width="40%"
                    id={item?.article_code}
                    onKeyPress={(e) => {
                      if (
                        e.key === " " ||
                        (e.key === "." && e.target.value.includes("."))
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      // Use regular expression to remove non-numeric and non-decimal characters
                      const numericValue = e.target.value.replace(
                        /[^0-9.]/g,
                        ""
                      );
                      handleCustomQty(numericValue, item?.article_code);
                    }}
                    value={item?.qty}
                    defaultValue={item?.qty}
                  />
                </div>
              </td>
              {/* <td>{item?.tp}</td> */}
              <td className="col-2  ">
                <SelectTpDamage
                  sc={item?.id}
                  setVal={item?.tp}
                  handleOnChangeCategory={handleOnChangePrice}
                  // handleCustomMrp={handleCustomMrp}
                ></SelectTpDamage>
              </td>
              <td className="">{parseFloat(item?.tp * item?.qty).toFixed(2)}</td>
              <td>
                <Textarea
                  type="text"
                  className="form-control quantity"
                  width="30%"
                  rows="1"
                  value={item?.reason || ""}
                  onChange={(e) =>
                    handleCustomReason(e.target.value, item?.article_code)
                  }
                />
              </td>
              <td>
                <Icons.X
                  size={20}
                  onClick={() => removeFromCart(item?.id)}
                ></Icons.X>
              </td>
            </tr>
          ))
      ) : (
        <tr>
          <td colSpan={7}>
            {/* <p className="text-center m-2">
                            Please select product
                        </p> */}
          </td>
        </tr>
      )}
    </>
  );
};

export default DamageProducts;
